import Reservations     from "../../../domain/reservation/Reservations";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_RESERVATIONS = "SET_RESERVATIONS",
}

export interface SetReservationsAction extends ResKaReduxAction {
  reservations: Reservations;
}

export type ReservationsAction = SetReservationsAction;

export const setReservationsAction = (reservations: Reservations): SetReservationsAction => ({
  type: ACTION_TYPE.SET_RESERVATIONS,
  reservations: reservations,
});